import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import App from './App';
import { ShopifyProvider, isEmbeddedApp } from './providers/ShopifyProvider';
import './index.css';

// Shopify API Key from environment or config
const SHOPIFY_API_KEY = import.meta.env.VITE_SHOPIFY_API_KEY || '01afaa5a0d92fde65491fa769ab3075e';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10000,
      refetchInterval: 30000,
    },
  },
});

// Detect if we're running embedded in Shopify
const embedded = isEmbeddedApp();

// Use MemoryRouter for embedded apps (App Bridge handles navigation)
// Use BrowserRouter for standalone access
const Router = embedded ? MemoryRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ShopifyProvider apiKey={SHOPIFY_API_KEY}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <App />
        </Router>
      </QueryClientProvider>
    </ShopifyProvider>
  </React.StrictMode>
);
